module.exports = __webpack_public_path__ + "img/2.76266e77.jpg";